// @ts-nocheck
import getShowPricing from "@store/Framework/Common/Utilities/getShowPricing";
import convertSelectorToHooks from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

const useShowPricing = convertSelectorToHooks(getShowPricing);

export default useShowPricing;
